import Config from './Config';

const PICKUP_ID_HEADER_REGEX = /^X-ProtectedTrust-PickupID\: \<([a-zA-Z0-9]{12})@(.*?)\>$/m;
const NOTIFICATION_TYPE_HEADER_REGEX = /^X-ProtectedTrust-Type\: (.*?)$/m;

const PR_TRANSPORT_MESSAGE_HEADERS = "0x007D";
const PROTECTEDTRUST_PROPERTYSET_ID = "{F697D419-984E-4271-8D03-FDC13D1CDE4A}";
const PROTECTEDTRUST_SentPickupID = "SentPickupID";

const PR_TRANSPORT_MESSAGE_HEADERS_EWS_RESPONSE = '0x7d';

export default class ReadMessageHelper {

    private _item: Office.ItemRead;

    private _propMimeHeaders: string;
    private _propSentPickupId: string;

    private _isEnvoyMessage?: boolean;
    private _isSender?: boolean;
    private _pickupId?: string;
    private _error: any;

    isEnvoyMessage(): boolean {
        if (this._isEnvoyMessage == null) {
            throw 'Must call loadAsync() before accessing this member.';
        }
        else {
            return this._isEnvoyMessage;
        }
    }

    isSender(): boolean {
        if (this._isSender == null) {
            throw 'Must call loadAsync() before accessing this member.';
        }
        else {
            return this._isSender;
        }

    }

    pickupId(): string {
        if (this._pickupId == null) {
            throw 'Must call loadAsync() before accessing this member.';
        }
        else {
            return this._pickupId;
        }

    }

    loadAsync(item: Office.ItemRead, callback: (error?: any) => void) {
        this._item = item;

        this._getMessageHeadersAsync(item, (error?: any) => {

            if (error) {
                callback(error);
                return;
            }

            if (this._propMimeHeaders != null && this._propMimeHeaders.length > 0) {
                var pickupMatch = PICKUP_ID_HEADER_REGEX.exec(this._propMimeHeaders);

                if (pickupMatch == null) {
                    this._isEnvoyMessage = false;
                    this._isSender = false;
                    callback();
                    return;
                }

                var pickupId: string = pickupMatch[1] || "";
                var coreServerUrl: string = pickupMatch[2] || "";

                var isSafeUrl = Config.getCoreBaseUrl() == ("https://" + coreServerUrl);

                if (!isSafeUrl) {
                    console.log("Unsupported server URL: " + coreServerUrl);
                    this._isEnvoyMessage = false;
                    this._isSender = false;
                    callback();
                    return;
                }

                var notificiationTypeMatch = NOTIFICATION_TYPE_HEADER_REGEX.exec(this._propMimeHeaders);
                var notificationType: string;
                if (notificiationTypeMatch != null) {
                    notificationType = notificiationTypeMatch[1] || "";
                }
                else {
                    notificationType = "ProtectedMessage";
                }

                this._isEnvoyMessage = true;
                this._isSender = (notificationType == "SentMessage");
                this._pickupId = pickupId;
                callback();
            }
            else if (this._propSentPickupId != null && this._propSentPickupId.length > 0) {
                // this is a message that was sent using the Outlook COM add-in - it has no MIME headers,
                // but does have a custom property called "SentPickupID"
                this._isEnvoyMessage = true;
                this._isSender = true;
                this._pickupId = this._propSentPickupId;
                callback();
            }
            else {
                this._isEnvoyMessage = false;
                this._isSender = false;
                callback();
                console.warn("No properties were found on this message.");
            }
        });
    }

    private _getMessageHeadersAsync(item: Office.ItemRead, callback: (error?: any) => void) {
        var soapRequest = this._makeGetHeadersRequest(item);

        try {
            Office.context.mailbox.makeEwsRequestAsync(soapRequest, (asyncResult) => {
                var soapResponse = asyncResult.value;
                //console.log(soapResponse);

                try {
                    var xml: JQuery = jQuery(jQuery.parseXML(soapResponse));

                    console.log(xml);

                    this._propMimeHeaders = this._getPropertyValue(xml, (node: JQuery) => {
                        var propTag = node.attr('PropertyTag') || '';
                        return propTag.toLowerCase() == PR_TRANSPORT_MESSAGE_HEADERS_EWS_RESPONSE.toLowerCase();
                    });

                    this._propSentPickupId = this._getPropertyValue(xml, (node: JQuery) => {
                        var propName = node.attr('PropertyName') || '';
                        return propName.toLowerCase() == PROTECTEDTRUST_SentPickupID.toLowerCase();
                    });

                    callback();
                }
                catch (e) {
                    console.error(e);
                    this._error = e;
                    callback(e);
                }

            });
        }
        catch (e) {
            console.error(e);
            this._error = e;
            callback(e);
        }
    }

    private _makeGetHeadersRequest(item: Office.ItemRead): string {

        var itemId = item.itemId;
        if (itemId == null) {
            // during the Office.EventType.ItemChanged event, the event argument initialData has the item id stored in a property called 'id'.
            itemId = (item as any).id;
        }

        var request =
            "<?xml version='1.0' encoding='utf-8'?>" +
            "<soap:Envelope xmlns:soap='http://schemas.xmlsoap.org/soap/envelope/'" +
            "               xmlns:t='http://schemas.microsoft.com/exchange/services/2006/types'>" +
            "  <soap:Header>" +
            "     <t:RequestServerVersion Version='Exchange2013'/>" +
            "  </soap:Header>" +
            "  <soap:Body>" +
            "    <GetItem xmlns='http://schemas.microsoft.com/exchange/services/2006/messages'>" +
            "      <ItemShape>" +
            "        <t:BaseShape>IdOnly</t:BaseShape>" +
            "        <t:BodyType>Text</t:BodyType>" +
            "        <t:AdditionalProperties>" +
            "            <t:ExtendedFieldURI PropertyTag='" + PR_TRANSPORT_MESSAGE_HEADERS + "' PropertyType='String' />" +
            "            <t:ExtendedFieldURI PropertySetId='" + PROTECTEDTRUST_PROPERTYSET_ID + "' PropertyName='" + PROTECTEDTRUST_SentPickupID + "' PropertyType='String' />" +
            "        </t:AdditionalProperties>" +
            "      </ItemShape>" +
            "      <ItemIds><t:ItemId Id='" + itemId + "'/></ItemIds>" +
            "    </GetItem>" +
            "  </soap:Body>" +
            "</soap:Envelope>";
        return request;
    }

    private _getPropertyValue(xml: JQuery, propUriFilter: (node: JQuery) => boolean): string {
        var uriElements = xml.find("*").filter(function () {
            return this.nodeName === "t:ExtendedFieldURI";
        });

        console.log(uriElements);

        if (uriElements == null || uriElements.length == 0) {
            console.log("Node not found: t:ExtendedFieldURI");
            return null;
        }

        var value: string;

        uriElements.each((index: number, uriElement: Element) => {
            if (propUriFilter(jQuery(uriElement))) {
                var valueEle = jQuery(uriElement).parent().children().filter(function () {
                    return this.nodeName == "t:Value";
                });

                value = valueEle.text();
            }
        });

        return value;
    }


}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/ReadMessageHelper.ts